export const ImportJsonExample = {
  companyCNPJ: '12345678000123',
  deductibleValue: 150,
  totalPartsValue: 200,
  totalServicesValue: 100,
  licensePlate: 'AAA0000',
  customer: {
    name: 'JOÃO SILVA',
    documentNumber: '12345678900',
    address: {
      zipCode: '12345000',
      state: 'SP',
      city: 'São Paulo',
      district: 'Centro',
      street: 'Rua Fictícia',
      number: '100',
      complement: 'Apto 101',
    },
  },
  insurer: {
    cnpj: '98765432000198',
    name: 'FICTÍCIA SEGURADORA S.A.',
    address: {
      zipCode: '54321000',
      state: 'RJ',
      city: 'Rio de Janeiro',
      district: 'Copacabana',
      street: 'Avenida Imaginária',
      number: '200',
    },
  },
  items: [
    {
      description: 'PEÇA FICTÍCIA 1',
      isProvided: false,
      isPart: true,
      quantity: 1,
      unitPrice: 220,
      unitCost: 180,
      discount: 20,
    },
    {
      description: 'SERVIÇO FICTÍCIO 1',
      isProvided: false,
      isPart: false,
      quantity: 1,
      unitPrice: 100,
    },
  ],
};
